<template>

  <div class="newsletter-sign-up">
    <div class="row">
      <div class="col-xs-4 col-sm-3 col-md-4 col-lg-2">
        <img src="/img/orbital/icons/join-us.svg" alt="Join over 7000 tradespeople icon" class="img-responsive">
      </div>
      <div class="col-xs-8 col-sm-9 col-md-6 col-lg-6">
        <p class="newsletter-sign-up__intro">Be the first to receive our latest promotional discounts &amp; savings!</p>

        <div class="checkbox--blue-lg">
          <label>
            <input type="checkbox" v-model="subscribe">
            <span class="faux-label">Yes please</span>
          </label>
        </div>

        <p class="newsletter-sign-up__disclaimer"><small class="text-muted">By providing your details, you consent to receiving this information by email and other electronic means (including social media).</small></p>
      </div>
    </div>
  </div>
</template>

<script>
    import Marketing from '../../Services/Marketing.js';
    export default {
        props: {
            email: {
                type: String,
                required: true,
            },
            triggerSave: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                subscribe: false,
            }
        },
        watch: {
            triggerSave(val) {
                if (val && this.subscribe) {
                    this.save();
                }
            }
        },
        methods: {
            save() {
                Marketing.subscribe(this.email).then(response => {
                }).catch(errors => {
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/NewsletterSignup.vue